import React from 'react'

import {BaseTemplate} from 'src/products/general/components/templates/BaseTemplate/BaseTemplate'

import {ProhibitedBusinessMethodsTemplate} from 'src/products/general/ProhibitedBusinessMethods/ProhibitedBusinessMethodsTemplate'

type Props = {
  onComplete: () => Promise<void>
}

export const ProhibitedBusinessMethodsGQLContainer: React.FC<Props> = ({
  onComplete: handleOnComplete,
}) => {
  return (
    <BaseTemplate>
      <ProhibitedBusinessMethodsTemplate onComplete={handleOnComplete} />
    </BaseTemplate>
  )
}
